import Home from "./pages/Home";
import React from "react";
import { ToastContainer } from "react-toastify";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { Provider } from "react-redux";
import { persistor, store } from "./store/index";
import { PersistGate } from "redux-persist/integration/react";
import FullscreenProgress from "./components/layout/FullscreenProgress";

import MainLayout from "./layouts/MainLayout";
import ProtectedRoute from "./components/common/ProtectedRoute";
import Login from "./pages/Login";
import GC from "./pages/GC";
import OrderHistory from "./pages/OrderHistory";
import Menu from "./pages/Menu";

const App: React.FC = () => {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        {/* Main Layout Routes */}
        <Route
          path="/"
          element={<MainLayout />}
        >
          <Route
            index
            element={
              <ProtectedRoute
                Element={Home}
                redirectTo="/login"
              />
            }
          />
          <Route
            path="/conditions-generales"
            element={
              <ProtectedRoute
                Element={GC}
                redirectTo="/login"
              />
            }
          />
          <Route
            path="/order-history"
            element={
              <ProtectedRoute
                Element={OrderHistory}
                redirectTo="/login"
              />
            }
          />
          <Route
            path="/my-menu"
            element={
              <ProtectedRoute
                Element={Menu}
                redirectTo="/login"
              />
            }
          />
        </Route>
        <Route
          element={<Login />}
          path="/login"
        />
      </>
    )
  );

  return (
    <Provider store={store}>
      <PersistGate
        loading={<FullscreenProgress />}
        persistor={persistor}
      >
        <RouterProvider router={router} />
        <ToastContainer
          position="bottom-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </PersistGate>
    </Provider>
  );
};

export default App;
